import crypto from 'crypto'
export function cleanupSpaces(str: string) {
  return str.trim().replace(/\s+/g, ' ')
}

export function titleCase(str: string) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt[0].toUpperCase() + txt.slice(1).toLowerCase()
  })
}

export function stricmp(str1: string | undefined | null, str2: string | undefined | null) {
  return (str1?.toLowerCase() ?? null) === (str2?.toLowerCase() ?? null)
}

export function md5(str: string) {
  return crypto.createHash('md5').update(str).digest('hex')
}
